export default __webpack_public_path__ + "static/media/bwLine153.eef22d81.svg";